var map = {
	"./audio-placeholder": 878,
	"./audio-placeholder.png": 878,
	"./avatar-missing": 581,
	"./avatar-missing.png": 581,
	"./avatar-missing.svg": 937,
	"./halloween/clouds": 879,
	"./halloween/clouds.png": 879,
	"./halloween/halloween-emblem": 880,
	"./halloween/halloween-emblem.svg": 880,
	"./halloween/spider": 881,
	"./halloween/spider.svg": 881,
	"./halloween/spiderweb": 882,
	"./halloween/spiderweb.svg": 882,
	"./halloween/starfield": 883,
	"./halloween/starfield.png": 883,
	"./halloween/twinkle": 884,
	"./halloween/twinkle.svg": 884,
	"./header-missing": 680,
	"./header-missing.png": 680,
	"./reticle": 885,
	"./reticle.png": 885,
	"./soapbox-logo": 681,
	"./soapbox-logo-white": 682,
	"./soapbox-logo-white.svg": 682,
	"./soapbox-logo.svg": 681,
	"./sprite-post-functions": 886,
	"./sprite-post-functions.png": 886,
	"./video-placeholder": 887,
	"./video-placeholder.png": 887,
	"./void": 888,
	"./void.png": 888,
	"./web-push/web-push-icon_expand": 889,
	"./web-push/web-push-icon_expand.png": 889,
	"./web-push/web-push-icon_favourite": 890,
	"./web-push/web-push-icon_favourite.png": 890,
	"./web-push/web-push-icon_reblog": 891,
	"./web-push/web-push-icon_reblog.png": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;